var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 648.22 648.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 24px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.2,503.33h-28.96v-177.41l28.96,28.96v148.45ZM137.65,235.4l159.31,159.31h36.21L108.68,170.23v333.1h28.96V235.4ZM449.02,503.33h28.96s0-177.41,0-177.41l-28.96,28.96v148.45ZM369.37,340.4l-195.51-195.51h-36.21l231.72,231.72,141.2-141.2v267.93h28.96V170.23l-170.17,170.17ZM510.57,144.89h-39.83l-119.48,119.48,19.91,19.91,139.39-139.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12,
    y: 12,
    width: 624.22,
    height: 624.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.9d4e8527bf09ea4230c9851e56b0909b.svg";
export { ForwardRef as ReactComponent };